import React from "react";

const Testimonial = ({
    quote,
    name,
    position,
    company,
    image,
    rating,
    headingLevel = "h3",
}) => {
    const Heading = headingLevel;

    return (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row">
            {/* Left part: comment, name, position, company */}
            <div className="p-8 md:w-3/5 flex flex-col justify-between">
                <div>
                    <p className="text-secondary-700 font-medium text-md mb-6 italic leading-relaxed">
                        "{quote}"
                    </p>
                </div>
                <div>
                    <Heading className="font-bold text-secondary-900 text-xl">
                        {name}
                    </Heading>
                    <p className="font-medium">{position}</p>
                    <p className="text-gray-500 mt-1">{company}</p>
                </div>
            </div>

            {/* Right part: portrait image taking full height */}
            <div className="md:w-2/5 relative hidden md:block">
                <img
                    src={image}
                    alt={name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default Testimonial;
